var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.536 15.0971L17.877 13.7562L10.377 6.25623L2.87695 13.7562L4.21786 15.0971L10.377 8.93806L16.536 15.0971Z",
    fill: "#565D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpLarge);
export default __webpack_public_path__ + "static/media/chevron-up-large.a8573eee24f30268361bf876150e9bfb.svg";
export { ForwardRef as ReactComponent };